import { SelectDropdown } from "@/components";
import React, { useContext, useMemo } from "react";
import { useCustomerCountries } from "@/hooks";
import { useTextDomainContext } from "@/app/providers";
import { CustomersCountryDropdownProps } from "./CustomersCountryDropdown.types";

export const CustomersCountryDropdown = (
  props: CustomersCountryDropdownProps,
) => {
  const {
    cacheKey,
    required,
    sx,
    refetch,
    refetched,
    customerId,
    subsidiaryId,
  } = props;
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const { countries: options } = useCustomerCountries(customerId, subsidiaryId);

  //#region useMemo
  const componentLabel = useMemo(() => {
    let label = gettext("Country");
    if (typeof props.componentLabel !== "undefined") {
      label = props.componentLabel;
    }
    return label;
  }, [gettext, props.componentLabel]);

  const defaultValue = useMemo(() => {
    let value = undefined;
    if (typeof props.defaultValue !== "undefined") {
      value = props.defaultValue;
    }
    return value;
  }, [props.defaultValue]);
  //#endregion useMemo

  //#region Handlers
  const handleChange = (event: any) => {
    if (event.value !== defaultValue) {
      if (typeof props.onChange === "function") {
        props.onChange(event);
      }
    }
  };
  //#endregion Handlers

  return (
    <SelectDropdown
      options={
        options as unknown as import("@/types/Dropdown.types").DropdownOption[]
      }
      componentLabel={componentLabel}
      defaultValue={defaultValue}
      showAll={props.showAll}
      cacheKey={cacheKey}
      required={required}
      onChange={handleChange}
      refetch={refetch || false}
      refetched={refetched}
      visualStyle="autoComplete"
      sx={{
        ...sx,
      }}
    />
  );
};
